import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["id"];
import { watchEffect, nextTick, onUnmounted } from "vue";
import * as echarts from 'echarts';
export default {
  __name: 'onlyLineAnalysis',
  props: {
    id: {
      type: String,
      default: 'echart'
    },
    data: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var series = [{
      name: '',
      type: 'line',
      stack: 'Total',
      yAxisIndex: 0,
      smooth: true,
      itemStyle: {
        color: '#295AF6'
      },
      showSymbol: false,
      data: []
    }, {
      name: '',
      type: 'line',
      stack: 'Total',
      yAxisIndex: 0,
      smooth: true,
      itemStyle: {
        color: '#ECBD45'
      },
      showSymbol: false,
      data: []
    }, {
      name: '',
      type: 'line',
      stack: 'Total',
      yAxisIndex: 0,
      smooth: true,
      itemStyle: {
        color: '#692FC8'
      },
      showSymbol: false,
      data: []
    }, {
      name: '',
      type: 'line',
      stack: 'Total',
      yAxisIndex: 0,
      smooth: true,
      itemStyle: {
        color: '#4E8FF1'
      },
      showSymbol: false,
      data: []
    }];
    var timer = null;
    var echartData = function echartData(data) {
      // let myChart = echarts.init(document.getElementById(props.id))
      var dom = document.getElementById(props.id);
      if (!dom) return;
      var myChart = echarts.init(dom);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
      var newSeries = data.series.map(function (item, index) {
        return _objectSpread(_objectSpread({}, series[index]), {}, {
          name: item.name,
          data: item.data.map(function (item) {
            return Number(item);
          })
        });
      });
      var option = {
        title: {
          text: data.title,
          left: 'center',
          show: data.showTitle
        },
        tooltip: {
          trigger: 'axis'
        },
        yAxis: [{
          type: 'value',
          name: '',
          position: 'left'
        }],
        legend: {
          bottom: 0,
          data: data.legend
        },
        xAxis: {
          type: 'category',
          data: data.xaxis
        },
        series: newSeries
      };
      option && myChart.setOption(option);
      timer = setTimeout(function () {
        myChart.resize();
      }, 100);
    };
    watchEffect(function () {
      // console.log(props.data,84)
      if (props.data && Object.keys(props.data).length > 0) {
        nextTick(function () {
          echartData(props.data);
        });
      }
    });
    onUnmounted(function () {
      if (timer) {
        clearTimeout(timer);
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        id: __props.id,
        style: {
          "width": "100%",
          "height": "300px"
        }
      }, null, 8, _hoisted_1);
    };
  }
};